import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import usePermission from "../../hooks/userAccess";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type DayOfWeek =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

interface Availability {
  enabled: boolean;
  start: string;
  end: string;
}

const StoreDetail = () => {
  const navigate = useNavigate();

  const { isView } = usePermission({
    label: 'Store Management',
    page_permission: 'isView',
  })

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [availability] = useState<Record<DayOfWeek, Availability>>({
    Monday: { enabled: true, start: "09:00", end: "18:00" },
    Tuesday: { enabled: true, start: "10:00", end: "17:00" },
    Wednesday: { enabled: false, start: "09:00", end: "18:00" },
    Thursday: { enabled: true, start: "09:00", end: "18:00" },
    Friday: { enabled: true, start: "09:00", end: "20:00" },
    Saturday: { enabled: false, start: "09:00", end: "18:00" },
    Sunday: { enabled: false, start: "09:00", end: "18:00" },
  });

  return (
    <>
      <div className="main_title">
        <h1>Store Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-stores")}>Store Management</button> -
          Store Detail
        </p>
      </div>

      {isView && <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Store Info" {...a11yProps(0)} />
              <Tab label="Store Availability" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>}

      {isView && <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Store Image</h6>
              <figure>
                <img alt="user" src="/static/images/placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Store Code</h6>
              <p>ST001</p>
            </div>
            <div className="w_33">
              <h6>Store Name</h6>
              <p>Downtown Store</p>
            </div>
            <div className="w_33">
              <h6>Store Manager Contact</h6>
              <p>+919876543110</p>
            </div>
            <div className="w_100">
              <h6>Address</h6>
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias, aspernatur.</p>
            </div>
            <div className="w_33">
              <h6>Region / City</h6>
              <p>New York</p>
            </div>
            <div className="w_33">
              <h6>Status</h6>
              <p className="c_success">Open</p>
            </div>
            <div className="w_33">
              <h6>Created Date</h6>
              <p>01-Sept-2025</p>
            </div>
            <div className="w_33">
              <h6>Order Online Link</h6>
              <p>www.orderonlinelink.com</p>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="gap_p">
            <div className="w_100">
              <h6>Weekly Availability</h6>
              <ul className="availability_list">
                {(Object.keys(availability) as DayOfWeek[]).map((day) =>
                  availability[day].enabled ? (
                    <li key={day}>
                      <strong>{day}:</strong> {availability[day].start} - {availability[day].end}
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          </div>
        </CustomTabPanel>
      </div>}
    </>
  );
};

export default StoreDetail;
